import React, { useEffect, useState } from "react";
import { Modal, ModalVariant } from "@patternfly/react-core";
import detailMediaListvView from "./mediaImages/detailMediaListvView.jpg";
import ProjectListMediaPopup from "./ProjectListMedia";
import ProjectListActionPopup from "./ProjectListActionModal";
import Pagination from "react-js-pagination";
import config from "../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import project from "../../../Reducers/Project";
import moment from "moment";

export default function ProjectListNew(props) {
  const [isModalProListViewAction, setisModalProListViewAction] =
    useState(false);
  const [isModalProListViewMedia, setisModalProListViewMedia] = useState(false);
  const [treeDataList, setTreeDataList] = useState([]);
  const [treeImageList, setTreeImageList] = useState([]);
  const [treeImageNewList, setTreeImageNewList] = useState([]);
  const [selectedTree, setSelectedTree] = useState({});
  const [healthyCount, setHealthyCount] = useState(0);
  const [unHealthyCount, setUnHealthyCount] = useState(0);
  const [droneLiDARCount, setDroneLidarCount] = useState(0);
  const [groundCount, setGroundCount] = useState(0);
  const [rgbCount, setRgbCount] = useState(0);
  const [allTreeCount, setAllTreeCount] = useState(0);
  const [searchText, setSearchText] = useState(null);
  const [treeTypeImage, SetTreeTypeImage] = useState([]);
  const [activeProjectTreeTypesGrid, SetActiveProjectTreeTypesGrid] = useState(
    []
  );
  const [selectedTreeData, setSelectedTreeData] = useState([]);
  const reduxState = useSelector((state) => state.project);
  const dispatch = useDispatch();
  const [activePage, setActivePage] = useState(1);
  const [pagesize, setPagesize] = useState(10);
  const [sortType, setSortType] = useState(true);
  const [up, setUp] = useState("active");
  const [down, setDown] = useState("");
  const [pageRange, setPageRange] = useState(10);
  const [status, setStatus] = useState(null);
  const [sortBy, setSortBy] = useState("tree_id");
  const [selectedSource, setSelectedSource] = useState("Ground Sampling");
  const [selectedTreeHealth, setSelectedTreeHealth] = useState("All");
  const [totalCount, setTotalCount] = useState(0);
  const [totalAllCount, setTotalAllCount] = useState(0);

  // useEffect(() => {
  //   if (reduxState.treeData) {
  //     setSelectedTreeData(reduxState.treeData);
  //   }
  // }, [reduxState.treeData]);

  useEffect(() => {
    setActivePage(1);
    setPagesize(10);
    setPageRange(10);
    setSelectedSource("Ground Sampling");
    setSelectedTreeHealth("All");
    GetAllTreeDetails(props.projectDetail.projectId, searchText);
  }, [props.projectDetail.projectId]);

  useEffect(() => {
    GetAllTreeDetails(props.projectDetail.projectId, searchText);
  }, [selectedSource, activePage, pagesize, pageRange, selectedTreeHealth]);

  const handleChangeSource = (event) => {
    setSelectedSource(event.target.value);
    // GetAllTreeDetails(props.projectDetail.projectId);
  };

  const handleChangeTreeHealth = (event) => {
    setSelectedTreeHealth(event.target.value);
    //GetAllTreeDetails(props.projectDetail.projectId);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    GetAllTreeDetails(props.projectDetail.projectId, searchText);
  };

  const handleSortClick = (SortBy) => {
    let up = "";
    let down = "active";
    let sortTypes = !sortType;

    if (sortTypes) {
      up = "active";
      down = "";
    }
    setSortBy(SortBy);
    setSortType(sortTypes);
    setUp(up);
    setDown(down);
    GetAllTreeDetails(props.projectDetail.projectId, searchText);
  };

  const handleModalProjectListAction = (eachTree) => {
    let speciesdata = treeImageList?.filter(
      (x) => x.speciesName === eachTree.common_name
    );
    setTreeImageNewList(speciesdata);
    setSelectedTree(eachTree);
    setisModalProListViewAction(!isModalProListViewAction);
    if (!isModalProListViewAction) {
      document.body.classList.remove("prolistviewbackdrop_cont");
      document.body.classList.add("prolistviewkmediabg_cont");
    } else {
      document.body.classList.add("prolistviewbackdrop_cont");
      document.body.classList.remove("prolistviewkmediabg_cont");
    }
  };

  const handleModalProjectListMedia = (eachTree) => {
    setSelectedTree(eachTree);
    setisModalProListViewMedia(!isModalProListViewMedia);
    if (!isModalProListViewMedia) {
      document.body.classList.remove("prolistviewbackdrop_cont");
      document.body.classList.add("prolistviewkmediabg_cont");
    } else {
      document.body.classList.add("prolistviewbackdrop_cont");
      document.body.classList.remove("prolistviewkmediabg_cont");
    }
  };

  const GetAllTreeDetails = (ProjectId, searchValue) => {
    let url = `${config.API_HOST_URL}/api/ProjectTreeTypes/GetAllTreeDetails/${activePage}/${pagesize}/${searchValue}/${sortType}/${sortBy}/${ProjectId}/${selectedTreeHealth}/${selectedSource}`;
    fetch(url, {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      timeout: 5000,
    })
      .then((response) => response.json())
      .then((data) => {
        let responseData = data?.list;
        let totalCount = data?.count;
        let totalAllCount = data?.count;
        let healthyCount = data?.healthyCount;
        let unHealthyCount = data?.unHealthyCount;
        let groundCount = data?.groundSamplingCount;
        let lidarCount = data?.droneLiDARCount;
        let rgbCount = data?.droneRGBCount;
        let TreeImage = data?.allImage;
        if (responseData !== null) {
          setTreeDataList(responseData);
          if (selectedTreeHealth == "Healthy") {
            setTotalCount(healthyCount);
            setTotalAllCount(healthyCount);
          } else if (selectedTreeHealth == "UnHealthy") {
            setTotalCount(unHealthyCount);
            setTotalAllCount(healthyCount);
          } else if (selectedTreeHealth == "All") {
            setTotalAllCount(healthyCount);
            setTotalCount(totalAllCount);
          }
          setHealthyCount(healthyCount);
          setUnHealthyCount(unHealthyCount);
          setGroundCount(groundCount);
          setDroneLidarCount(lidarCount);
          setRgbCount(rgbCount);
          setTreeImageList(TreeImage);
          //setTotalAllCount(totalAllCount);
        } else {
          setGroundCount(groundCount);
          setDroneLidarCount(lidarCount);
          setRgbCount(rgbCount);
          setTreeDataList(responseData);
          setTreeImageList(TreeImage);
          if (selectedTreeHealth == "Healthy") {
            setTotalCount(healthyCount);
            setTotalAllCount(healthyCount);
          } else if (selectedTreeHealth == "UnHealthy") {
            setTotalCount(unHealthyCount);
            setTotalAllCount(healthyCount);
          } else if (selectedTreeHealth == "All") {
            setTotalAllCount(healthyCount);
            setTotalCount(totalAllCount);
          }
          //setTotalCount(totalCount);
          setHealthyCount(healthyCount);
          setUnHealthyCount(unHealthyCount);
          //setTotalAllCount(totalAllCount);
        }
      })
      .catch((error) => {
        console.log("Error in request", error);
      });
  };

  const GetTreeTypeImage = (TreeTypeName) => {
    let UserDetail = {
      TreeTypeName: TreeTypeName,
    };
    let uri = `${config.API_HOST_URL}/api/TreeType/GetTreeTypeImage`;
    let fetchOptions = {
      method: "POST",
      body: JSON.stringify(UserDetail),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(uri, fetchOptions)
      .then((resp) => resp.json())
      .then((data) => {
        let records = JSON.parse(data.List);
        if (records.length > 0) {
          SetTreeTypeImage(
            `${config.Amazon_WebService_CDNUrl}/Websites/Uploads/TreeTypes/${records[0].TreeTypeImgPath}`
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetProjectTreeTypesGridDetail = (gridGuid) => {
    let uri = `${config.API_HOST_URL}/api/ProjectTreeTypes/GetProjectTreeTypesGridDetail/${gridGuid}`;
    let fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(uri, fetchOptions)
      .then((resp) => resp.json())
      .then((result) => {
        let records = result.data;
        if (records !== null) {
          SetActiveProjectTreeTypesGrid(records);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showTreeOnMap = (eachTree) => {
    // console.log("eachTree", eachTree);
    project(
      reduxState?.treeData,
      dispatch({ type: "SET_TREEDATA_DETAILS", data: eachTree })
    );
  };

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchByEnter = (event) => {
    if (event.key === "Enter") {
      executeSearch(event.target.value);
    }
  };

  const handleSearchClick = () => {
    executeSearch(searchText);
  };

  const executeSearch = (query) => {
    setSearchText(query);
    setActivePage(1);
    GetAllTreeDetails(props.projectDetail.projectId, query);
  };

  const handleBackspaces = (event) => {
    if (
      (event.key === "Delete" && event.code === "Delete") ||
      (event.key === "Backspace" && event.code === "Backspace")
    ) {
      setSearchText(null);
      setActivePage(1);
      GetAllTreeDetails(props.projectDetail.projectId, null);
    }
  };
  return (
    <>
      <div className="selectsearch_wrap">
        <select
          className="prolstvewpop_select"
          onChange={handleChangeSource}
          value={selectedSource}
        >
          <option value="Ground Sampling" selected="">
            Ground Sampling ({groundCount}){" "}
          </option>
          <option value="Drone LiDAR" selected="">
            Drone LiDAR ({droneLiDARCount}){" "}
          </option>
          <option value="Drone RGB" selected="">
            Drone RGB ({rgbCount}){" "}
          </option>
        </select>
        <select
          className="prolstvewpop_select"
          onChange={handleChangeTreeHealth}
          value={selectedTreeHealth}
        >
          <option value="All" selected="">
            All ({totalAllCount}){" "}
          </option>
          <option value="Healthy" selected="">
            Healthy ({healthyCount}){" "}
          </option>
          <option value="UnHealthy" selected="">
            Unhealthy ({unHealthyCount}){" "}
          </option>
        </select>
        <div className="projlistview_search">
          <input
            type="text"
            id="SearchText"
            autoFocus
            placeholder="Search for tree type, tree Id, species..."
            value={searchText}
            onChange={handleInputChange}
            onKeyPress={handleSearchByEnter}
            onKeyDown={handleBackspaces}
          />
          <div className="projlistsrchbtn" onClick={handleSearchClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M13.6583 12.0086L10.6967 9.04701C11.3086 8.12475 11.6668 7.02049 11.6668 5.83339C11.6668 2.61686 9.04993 0 5.83339 0C2.61686 0 0 2.61686 0 5.83339C0 9.04993 2.61686 11.6668 5.83339 11.6668C7.02049 11.6668 8.12475 11.3086 9.04701 10.6967L12.0086 13.6583C12.4636 14.1139 13.2033 14.1139 13.6583 13.6583C14.1139 13.2027 14.1139 12.4642 13.6583 12.0086ZM1.75002 5.83339C1.75002 3.5817 3.5817 1.75002 5.83339 1.75002C8.08508 1.75002 9.91677 3.5817 9.91677 5.83339C9.91677 8.08508 8.08508 9.91677 5.83339 9.91677C3.5817 9.91677 1.75002 8.08508 1.75002 5.83339Z"
                fill="#858585"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="Pojectsummary_cont">
        <table className="prolistviewtbl">
          <thead>
            {treeDataList ? (
              <tr>
                <th className="thGridNo">SN</th>
                <th className="treeididth">
                  Tree Id
                  <div
                    className="sortArrow"
                    onClick={() => handleSortClick("tree_id")}
                  >
                    <i
                      className={
                        sortBy === "tree_id"
                          ? `fas fa-sort-up ${up}`
                          : "fas fa-sort-up"
                      }
                    ></i>
                    <i
                      className={
                        sortBy === "tree_id"
                          ? `fas fa-sort-down ${down}`
                          : "fas fa-sort-down"
                      }
                    ></i>
                  </div>
                </th>
                <th className="treespeciesth">
                  Species Name{" "}
                  <div
                    className="sortArrow"
                    onClick={() => handleSortClick("species_name")}
                  >
                    <i
                      className={
                        sortBy === "species_name"
                          ? `fas fa-sort-up ${up}`
                          : "fas fa-sort-up"
                      }
                    ></i>
                    <i
                      className={
                        sortBy === "species_name"
                          ? `fas fa-sort-down ${down}`
                          : "fas fa-sort-down"
                      }
                    ></i>
                  </div>
                </th>
                {selectedSource === "Ground Sampling" && (
                  <th className="treeplantdtth">
                    Tree Planted Date
                    <div
                      className="sortArrow"
                      onClick={() => handleSortClick("planted_date")}
                    >
                      <i
                        className={
                          sortBy === "planted_date"
                            ? `fas fa-sort-up ${up}`
                            : "fas fa-sort-up"
                        }
                      ></i>
                      <i
                        className={
                          sortBy === "planted_date"
                            ? `fas fa-sort-down ${down}`
                            : "fas fa-sort-down"
                        }
                      ></i>
                    </div>
                  </th>
                )}
                <th className="treesstatusth">
                  Status
                  <div
                    className="sortArrow"
                    onClick={() => handleSortClick("tree_Status")}
                  >
                    <i
                      className={
                        sortBy === "tree_Status"
                          ? `fas fa-sort-up ${up}`
                          : "fas fa-sort-up"
                      }
                    ></i>
                    <i
                      className={
                        sortBy === "tree_Status"
                          ? `fas fa-sort-down ${down}`
                          : "fas fa-sort-down"
                      }
                    ></i>
                  </div>
                </th>
                {selectedSource === "Ground Sampling" && (
                  <th className="treesplantbyth">
                    Tree Planted By
                    <div
                      className="sortArrow"
                      onClick={() => handleSortClick("treePlantedby")}
                    >
                      <i
                        className={
                          sortBy === "treePlantedby"
                            ? `fas fa-sort-up ${up}`
                            : "fas fa-sort-up"
                        }
                      ></i>
                      <i
                        className={
                          sortBy === "treePlantedby"
                            ? `fas fa-sort-down ${down}`
                            : "fas fa-sort-down"
                        }
                      ></i>
                    </div>
                  </th>
                )}
                {selectedSource === "Ground Sampling" && (
                  <th className="treeheightth">
                    Tree Height (m)
                    <div
                      className="sortArrow"
                      onClick={() => handleSortClick("tree_height")}
                    >
                      <i
                        className={
                          sortBy === "tree_height"
                            ? `fas fa-sort-up ${up}`
                            : "fas fa-sort-up"
                        }
                      ></i>
                      <i
                        className={
                          sortBy === "tree_height"
                            ? `fas fa-sort-down ${down}`
                            : "fas fa-sort-down"
                        }
                      ></i>
                    </div>
                  </th>
                )}
                {/* <th className="treewealthth">
              Tree Health
              <div
                className="sortArrow"
                onClick={() => handleSortClick("tree_health")}
              >
                <i
                  className={
                    sortBy === "tree_health"
                      ? `fas fa-sort-up ${up}`
                      : "fas fa-sort-up"
                  }
                ></i>
                <i
                  className={
                    sortBy === "tree_health"
                      ? `fas fa-sort-down ${down}`
                      : "fas fa-sort-down"
                  }
                ></i>
              </div>
            </th> */}
                <th className="treesourceth">
                  Planting Organization
                  <div
                    className="sortArrow"
                    onClick={() => handleSortClick("source")}
                  >
                    <i
                      className={
                        sortBy === "source"
                          ? `fas fa-sort-up ${up}`
                          : "fas fa-sort-up"
                      }
                    ></i>
                    <i
                      className={
                        sortBy === "source"
                          ? `fas fa-sort-down ${down}`
                          : "fas fa-sort-down"
                      }
                    ></i>
                  </div>
                </th>
                {selectedSource === "Ground Sampling" && (
                  <th className="treemediath"> Media </th>
                )}
                <th className="treeactionsth">Actions</th>
              </tr>
            ) : (
              ""
            )}
          </thead>
          <tbody>
            {treeDataList ? (
              treeDataList.map((eachTree, index) => {
                return (
                  <tr
                    key={eachTree?.id ? eachTree?.id : index}
                    className={
                      reduxState?.treeData?.tree_id === eachTree?.tree_id
                        ? "listTrActive"
                        : ""
                    }
                  >
                    <td className="tdGridNo">{index + 1}</td>
                    <td className="idtd treeidtd">
                      <a onClick={() => showTreeOnMap(eachTree)}>
                        {eachTree?.tree_id ? eachTree?.tree_id : "-"}
                      </a>
                    </td>
                    <td className="treetypetd">
                      <span style={{ fontWeight: "bold" }}>
                        {eachTree?.common_name
                          ? eachTree?.common_name
                          : eachTree?.latin_name
                          ? eachTree?.latin_name
                          : "-"}
                      </span>
                    </td>
                    {selectedSource === "Ground Sampling" && (
                      <td className="idtd">
                        {eachTree?.planted_date
                          ? moment(eachTree?.planted_date)
                              .format("DD MMM YYYY")
                              .toUpperCase()
                          : "-"}
                      </td>
                    )}
                    <td className="idtd alivetd treesstatustd">
                      <span>
                        {eachTree?.tree_Status ? eachTree?.tree_Status : "-"}
                      </span>
                    </td>
                    {selectedSource === "Ground Sampling" && (
                      <td className="idtd treesplantbytd">
                        {eachTree?.treePlantedby
                          ? eachTree?.treePlantedby
                          : "-"}
                      </td>
                    )}
                    {selectedSource === "Ground Sampling" && (
                      <td className="idtd treeheighttd">
                        {eachTree?.tree_height ? eachTree?.tree_height : "-"}
                      </td>
                    )}
                    {/* <td className="idtd treewealthtd">
            {eachTree?.tree_health ? eachTree?.tree_health : "-"}
          </td> */}
                    <td className="idtd treesourcetd">
                      {eachTree?.source ? eachTree?.source : "-"}
                    </td>
                    {selectedSource === "Ground Sampling" && (
                      <td className="idtd listviewmediatd">
                        {/* Same have to check video as well from this field */}
                        {eachTree.photos && eachTree.photos.length > 0 ? (
                          <a
                            className="listviewmedia_popup"
                            onClick={() =>
                              handleModalProjectListMedia(eachTree)
                            }
                          >
                            <img
                              src={
                                `${config.Amazon_WebService_CDNUrl}/Websites/Uploads/TreesImages/${eachTree?.projectID}/${eachTree?.ec5_uuid}/` +
                                eachTree?.photos?.[0]
                              }
                              alt="trees plant"
                            />
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                    )}
                    <td className="action_cont">
                      <a
                        title="Details"
                        onClick={() => handleModalProjectListAction(eachTree)}
                      >
                        <i className="fas fa-satellite"></i>
                      </a>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td>Records not found</td>
              </tr>
            )}
          </tbody>
        </table>
        <Modal
          title="listViewTitle"
          ariaLabel="listView"
          ariaLabelledby="list-view-title"
          isOpen={isModalProListViewMedia}
          onClose={handleModalProjectListMedia}
          className="projdetailpage_modal projdetimgcarusel_modal"
        >
          <ProjectListMediaPopup eachTreeData={selectedTree} />
        </Modal>

        <Modal
          title="listViewActionModal"
          ariaLabel="listView"
          ariaLabelledby="list-view-title"
          isOpen={isModalProListViewAction}
          onClose={handleModalProjectListAction}
          className="projdetailpage_modal projdetaction_modal"
        >
          <ProjectListActionPopup
            eachTreeData={selectedTree}
            speceiestreedata={treeImageNewList}
          />
        </Modal>

        <div className="paginationDiv">
          <Pagination
            activePage={activePage}
            itemsCountPerPage={pagesize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={pageRange}
            nextPageText={<i className="fa fa-angle-right"></i>}
            prevPageText={<i className="fa fa-angle-left"></i>}
            onChange={(pageNumber) => handlePageChange(pageNumber)}
          />
        </div>
      </div>
    </>
  );
}
